<div class="container mt-5 mb-5">
  <div class="row justify-content-center">
    <div class="col-md-8 col-lg-6">

      <div class="card shadow-sm">
        <div class="card-body p-4">
          <h2 class="card-title fw-bold mb-1">{{ 'register.title' | transloco }}</h2>
          <p class="text-body-secondary mb-4">{{ 'register.subtitle' | transloco }}</p>

          <form [formGroup]="form" (ngSubmit)="onSubmit()">

            <div class="mb-3">
              <label for="username" class="form-label">{{ 'register.username' | transloco }}</label>
              <input
                id="username"
                type="text"
                [formControl]="form.controls.username"
                class="form-control"
                [placeholder]="'register.usernamePlaceholder' | transloco"
              />
              @if (usernamesInvalid) {
                <div class="text-danger small mt-1">{{ 'register.usernameInvalid' | transloco }}</div>
              }
            </div>

            <div class="row g-3 mb-3">
              <div class="col-6">
                <label for="firstName" class="form-label">{{ 'register.firstName' | transloco }}</label>
                <input
                  id="firstName"
                  type="text"
                  [formControl]="form.controls.firstName"
                  class="form-control"
                />
                @if (firstNameIsInvalid) {
                  <div class="text-danger small mt-1">{{ 'register.firstNameInvalid' | transloco }}</div>
                }
              </div>
              <div class="col-6">
                <label for="lastName" class="form-label">{{ 'register.lastName' | transloco }}</label>
                <input
                  id="lastName"
                  type="text"
                  [formControl]="form.controls.lastName"
                  class="form-control"
                />
                @if (lastNameIsInvalid) {
                  <div class="text-danger small mt-1">{{ 'register.lastNameInvalid' | transloco }}</div>
                }
              </div>
            </div>

            <div class="mb-4">
              <label for="email" class="form-label">{{ 'register.email' | transloco }}</label>
              <input
                id="email"
                type="email"
                [formControl]="form.controls.email"
                class="form-control"
                [placeholder]="'register.emailPlaceholder' | transloco"
              />
              @if (emailIsInvalid) {
                <div class="text-danger small mt-1">{{ 'register.emailInvalid' | transloco }}</div>
              }
            </div>

            @if (captchaEnabled) {
              <div class="mb-3">
                <div id="turnstile-container"></div>
              </div>
            }

            @if (isLoading) {
              <div class="text-center text-body-secondary">{{ 'register.creating' | transloco }}</div>
            } @else if (!registrationSuccess) {
              <button type="submit" class="btn btn-primary w-100" [disabled]="isSubmitDisabled">{{ 'register.submit' | transloco }}</button>
            }

            @if (message) {
              <div class="alert mt-3 mb-0" [ngClass]="isError ? 'alert-danger' : 'alert-success'">
                {{ message }}
              </div>
            }

          </form>

          <hr class="my-4">

          <div class="text-center">
            <p class="text-body-secondary small mb-2">{{ 'register.orSkip' | transloco }}</p>
            <button (click)="login()" class="btn btn-outline-secondary w-100">
              <i class="bi bi-google me-2"></i>{{ 'register.loginGoogle' | transloco }}
            </button>
          </div>

        </div>
      </div>

    </div>
  </div>
</div>
